import 'react-responsive-carousel/lib/styles/carousel.min.css';
var React = require('react');
var Carousel = require('react-responsive-carousel').Carousel;

export default function MBCarousel() {        
    return (
        <Carousel showArrows={true} showThumbs={false} infiniteLoop={true} autoPlay={true} interval={5000} /*onChange={onChange} onClickItem={onClickItem} onClickThumb={onClickThumb}*/>                        
            <div>
                <img src={require("assets/img/EnableAMGMenu.jpg")} alt="Enabling AMG Menu for All Cars"/>
                <p className="legend">Enabling AMG Menu for All Cars</p>
            </div>
            <div>
                <img src={require("assets/img/InstantMapCodes.jpg")} alt="Instantly Genarate Navigation Codes"/>
                <p className="legend">Instantly Genarate Navigation Codes</p>
            </div>
            
        </Carousel>
    );
};